/**
 * 入力履歴（mst003）テーブル操作用メソッド 
 */

// メモった！、キニッタ！共通メソッド
import * as GVar from '@/components/00/Var00';          // 共通変数
import * as Tools from '@/components/00/Tools';         // 共通ツール
import * as GFunc from '@/components/00/Common00';    // 共通メソッド
import * as Mst001 from '@/components/00/db/Mst001'; 

export class Mst003DTO
{
   sys_cd = "";      // システムコード
   tmplt_cd = "";  // テンプレートコード
   pnlId = "";	    // 画面ID
   objId = "";	    // オブジェクトID
   objVal = "";	// オブジェクト値
   updTs = "";	    // 更新日時

   constructor (sys_cd: string, tmplt_cd: string, pnlId: string, objId: string, objVal: string, updTs: string)
   {
       this.sys_cd = sys_cd;      // システムコード
       this.tmplt_cd = tmplt_cd;  // テンプレートコード
       this.pnlId = pnlId;	    // 画面ID
       this.objId = objId;	    // オブジェクトID
       this.objVal = objVal;	// オブジェクト値
       this.updTs = updTs;	    // 更新日時
   }
}

/**
 * mst003テーブル新規作成
 */
export const create = async function()
{
    const tabaleId = "mst003";
    if ( GFunc.isDebugEnabled() ) {console.log(tabaleId+" create()");}
    try
    {
        // テーブル新規作成
        const resp = await GVar.db.run("CREATE TABLE IF NOT EXISTS mst003 (sys_cd text, tmplt_cd text, uid integer, pnl_id text, obj_id text, obj_val text, upd_ts text, PRIMARY KEY (sys_cd, tmplt_cd, uid, pnl_id, obj_id , obj_val))");
        // バージョンNo.保存
        await Mst001.updateTabelVersionNo(tabaleId);
        if ( GFunc.isDebugEnabled() ) {console.log(tabaleId+"テーブルを作成しました。", resp);}
        return true;
    }
    catch(e)
    {
        console.log(GVar.sqliteErrorMsg+tabaleId+"テーブルの作成に失敗しました。："+`${e}`);
    }
}

/**
 * 入力履歴から入力候補一覧を取得する
 *
 * @param pnlId 画面ID
 * @param objId 画面内のオブジェクトID
 */
export const getSuggestList = async function(pnlId: string, objId: string)
{
    if ( GFunc.isDebugEnabled() ) { console.log("getSuggestList()"); }
    // 未ログインの場合、uidは0を設定
    let uid = 0;
    if ( GFunc.isLoggedin() ) { uid =  GFunc.getUi().uid.value; }
    try
    {
        const result = await GVar.db.query("select *, rowid from mst003 where sys_cd = ? and tmplt_cd = ? and uid = ? and  pnl_id = ? and obj_id = ? order by upd_ts desc",
                    [GVar.sysCd, GVar.tmpltCd, uid, pnlId, objId]);
        return result;
    }
    catch(e)
    {
        console.log(GVar.sqliteErrorMsg+`${e}`);
        return null;
    }
}

/**
 * 入力履歴に追加する
 * 既に同じ値が存在する場合は更新日時のみ更新、存在しない場合は追加する
 * @param pnlId 画面ID
 * @param objId 画面内のオブジェクトID
 * @param objVal 値
 */
export const addSuggestList = async function (pnlId: string, objId: string, objVal: string)
{
    if ( GFunc.isDebugEnabled() ) { console.log("addSuggestList()"); }

    if ( objVal == null || objVal.length == 0 ) { return; }
    // 未ログインの場合、uidは0を設定
    let uid = 0;
    if ( GFunc.isLoggedin() ) { uid =  GFunc.getUi().uid.value; }
    try
    {
        const result = await GVar.db.query("select * from mst003 where sys_cd = ? and tmplt_cd = ? and uid = ? and pnl_id = ? and obj_id = ? and obj_val = ?",
                    [GVar.sysCd, GVar.tmpltCd, uid, pnlId, objId, objVal]);
        if ( result.values.length > 0 )
        {
            // 同一PKのレコードが存在するので更新日時のみ更新する
            await GVar.db.run('update mst003 set upd_ts = ? where sys_cd = ? and tmplt_cd = ? and uid = ? and pnl_id = ? and obj_id = ? and obj_val = ?',
                [Tools.getCurrentYyyymmddhhmmss(), GVar.sysCd, GVar.tmpltCd, uid, pnlId, objId, objVal]);
        }
        else
        {
            // 同一PKのレコードが存在しないので追加する
            await GVar.db.run('insert into mst003 (sys_cd, tmplt_cd, uid, pnl_id, obj_id, obj_val, upd_ts) VALUES (?,?,?,?,?,?,?)',
                [GVar.sysCd, GVar.tmpltCd, uid, pnlId, objId, objVal, Tools.getCurrentYyyymmddhhmmss()]);
        }
    }
    catch(e)
    {
        console.log(GVar.sqliteErrorMsg+`${e}`);
    }
}

/**
 * 入力履歴から削除する
 * @param rowid 削除する行ID
 */
export const deleteSuggestion = async function(rowid: number)
{
    if ( GFunc.isDebugEnabled() ) { console.log("deleteSuggestion() rowid="+rowid); }
    try
    {
        await GVar.db.run("delete from mst003 where rowid = ? ", [rowid]);
    }
    catch(e)
    {
        console.log(GVar.sqliteErrorMsg+`${e}`);
    }
}